<template>
    <v-dialog
        v-model="dialog"
        hide-overlay
        persistent
        max-width="600px"
        transition="dialog-bottom-transition"
    >
        <v-card>
            <v-card-title>
                <p style="margin: 0 auto;">Current Shift</p>
            </v-card-title>

            <v-alert
                text
                dense
                color="black"
                icon="mdi-account-alert"
                border="left"
                style="margin: 0;padding-left: 30px;"
            >
                <p style="margin: 0;">
                    <strong>{{ currentShiftData[0].DriverName }}</strong>
                </p>
                <p style="margin: 0;">
                    currently has a Shift in progress or not completed.
                </p>
                <p style="margin: 0;">
                    From the Date:
                    <strong
                        >{{ currentShiftData[0].Date }}
                        {{ currentShiftData[0].Shift }}</strong
                    >.
                </p>
                <p style="margin: 0;">
                    From the ShiftDetail:
                    <strong>{{ currentShiftData[0].ShiftDetail }}</strong
                    >.
                </p>
            </v-alert>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="black" text @click="dialog = false">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'DriverCurrentShift',
    props: ['value', 'currentShiftData'],
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    }
};
</script>
